enum BANNER_BUTTON_TYPE{
  catalog = 'В каталог',
  transfer = 'Перейти',
  about = 'Подробнее',
  none = 'Не добавлять'
}
export default BANNER_BUTTON_TYPE
